
    var riot = require('riot')
    
riot.tag2('teamadmin', '<div class="teamadmin"> <div class="row"> <div class="col-xs-12"> <ul class="nav nav-tabs"> <li class="{active:tab==\'orgdetails\'}"><a href="#" onclick="{settab}" name="orgdetails"> Organisation Details</a></li> <li class="{active:tab==\'members\'}"><a href="#" onclick="{settab}" name="members">Team Members</a></li> </ul> </div> </div> <div if="{tab==\'orgdetails\'}" class="row"> <div class="col-xs-12 tabpanel"> <formhorizontal submit="{saveOrg}"> <h3>Organisation Details</h3> <div class="row"> <div class="col-xs-12 col-sm-12"> <div class="row"> <label class="control-label col-sm-4">Company Logo</label> <div class="col-xs-12 col-sm-2"> <div class="avatar"> <uploadimage on-click="{parent.uploadimage}"><img riot-tag="img_loader" riot-src="{\'/images/org_logos/\'+parent.parent.org.id+\'.jpg?q=\'+parent.parent.cachebuster}" default="/images/assets/maintenance-logo.svg"></uploadimage> </div> </div> <div class="col-xs-12 col-sm-6"> <div class="well">Click the logo opposite to upload your logo.<br> Please ensure your logo is provided as a jpeg image.</div> </div> </div> <forminput label="Organisation name" name="name" value="{parent.org.name}" readonly="true"></forminput> <forminput label="Trading Name" name="trading_name" value="{parent.org.trading_name}" oninput="{parent.orgupdate}"></forminput> <formtextarea label="Address" name="address" value="{parent.org.address}" oninput="{parent.orgupdate}" rows="5"></formtextarea> <forminput label="Post/Zip Code" name="postcode" value="{parent.org.postcode}" oninput="{parent.orgupdate}"></forminput> <forminput label="Primary Email" name="email" value="{parent.org.email}" readonly="true"></forminput> <forminput label="Website" name="website" value="{parent.org.website}" oninput="{parent.orgupdate}"></forminput> <forminput label="Phone" name="phone" value="{parent.org.phone}" oninput="{parent.orgupdate}"></forminput> <forminput show="{[1,2,3].indexOf(parent.org.membership_category)&gt;-1 || parent.org.solutions_provider}" label="No. of Telecare Connections" name="telecare_connections" value="{parent.org.telecare_connections}" oninput="{parent.orgupdate}"></forminput> <formselect show="{[1,2,3].indexOf(parent.org.membership_category)&gt;-1 || parent.org.solutions_provider}" label="Service Geography" name="geography" value="{parent.org.geography}" oninput="{parent.orgupdate}" options="{parent.serviceGeographyOptions}"></formselect> <formtextarea label="Profile ({999-parent.org.description.length} characters left)" name="description" value="{parent.org.description}" oninput="{parent.orgupdate}" rows="10"></formtextarea> <div show="{description.value.length &gt; 999}" class="alert alert-danger"> <p>Your profile is too long. Please reduce to 999 characters or less.</p> </div> </div> <div show="{[1,2,3].indexOf(parent.org.membership_category)&gt;-1  || parent.org.solutions_provider}"> <div class="col-xs-12 col-sm-8"> <div class="panel-defaultv"> <div class="panel-heading"> <h3 class="panel-title">Service Needs</h3> </div> <div class="panel-body"> <div class="row"> <div class="col-xs-12 col-sm-7"> <div each="{val in parent.service_needsOptions.slice(0,8)}" class="checkbox"> <label> <input type="checkbox" name="service_needs" __checked="{parent.parent.org.service_needs.indexOf(val)&gt;-1 ? true : false}" onchange="{parent.parent.updateOrgCheck.bind(this,val)}"> {val} </label> </div> </div> <div class="col-xs-12 col-sm-5"> <div each="{val in parent.service_needsOptions.slice(8,16)}" class="checkbox"> <label> <input type="checkbox" name="service_needs" __checked="{parent.parent.org.service_needs.indexOf(val)&gt;-1 ? true : false}" onchange="{parent.parent.updateOrgCheck.bind(this,val)}"> {val} </label> </div> </div> </div> </div> </div> </div> <div class="col-xs-12 col-sm-4"> <div class="panel-default"> <div class="panel-heading"> <h3 class="panel-title">Services Offered</h3> </div> <div class="panel-body"> <div each="{val in parent.services_offeredOptions}" class="checkbox"> <label> <input type="checkbox" name="services_offered" __checked="{parent.parent.org.services_offered.indexOf(val)&gt;-1 ? true : false}" onchange="{parent.parent.updateOrgCheck.bind(this,val)}"> {val} </label> </div> </div> </div> </div> </div> </div><br> <div class="btn-toolbar"> <div class="pull-right btn-toolbar"> <button onclick="{parent.close}" class="btn btn-default">Close </button> <button type="submit" __disabled="{parent.saving}" class="btn btn-primary">{parent.saving ? ⁗Saving⁗ : ⁗Save Changes⁗}</button> </div> </div><br> </formhorizontal> </div> </div> <div if="{tab==\'members\'}" class="row"> <div class="col-xs-12 tabpanel"> <table class="table table-striped"> <thead> <tr> <th>First Name</th> <th>Surname</th> <th>Email</th> </tr> </thead> <tbody> <tr each="{team}" onclick="{get}" class="{selected:parent.user.id==id}"> <td>{first_name}</td> <td>{surname}</td> <td>{email}</td> </tr> </tbody> </table> <div if="{loading}" class="alert alert-info"> <p> <span class="fa fa-refresh fa-spin fa-fw"> </span>Loading</p> </div> <formhorizontal width1="2" width2="10" if="{user}" submit="{save}"> <hr> <h3>Member Details</h3> <div style="height:0px;overflow:hidden"> <input type="text" name="username"> <input type="password" name="password"> </div> <formstatic label="Email Address" value="{parent.user.email}" if="{parent.user.id}"></formstatic> <forminput label="Email Address" name="email" value="{parent.user.email}" if="{!parent.user.id}" oninput="{parent.userupdate}" isrequired=""></forminput> <forminput label="First Name" name="first_name" value="{parent.user.first_name}" oninput="{parent.userupdate}"></forminput> <forminput label="Surname" name="surname" value="{parent.user.surname}" oninput="{parent.userupdate}"></forminput> <forminput label="Job Title" name="job_title" value="{parent.user.job_title}" oninput="{parent.userupdate}"></forminput> <formtextarea label="Address" name="address" value="{parent.user.address}" oninput="{parent.userupdate}"></formtextarea> <forminput label="Post/Zip Code" name="postcode" value="{parent.user.postcode}" oninput="{parent.userupdate}"></forminput> <forminput label="Phone" name="phone1" value="{parent.user.phone1}" oninput="{parent.userupdate}"></forminput> <forminput label="Mobile Phone" name="phone2" value="{parent.user.phone2}" oninput="{parent.userupdate}"></forminput> <forminput label="New Password" type="password" placeholder="Please leave blank, unless your wish to update" name="newpassword" value="{parent.password}" oninput="{parent.passupdate}"></forminput> <forminput if="{parent.password}" label="Confirm Password" type="password" placeholder="Please repeat above password" name="newpassword" value="{parent.password2}" oninput="{parent.passupdate2}"></forminput> <div if="{parent.password &amp;&amp; (parent.password!=parent.password2 || parent.password.length &lt; 8)}" class="alert alert-danger"> <p>Please ensure both passwords are the same and are over 7 characters long</p> </div> <div class="btn-toolbar"> <div class="pull-right btn-toolbar"> <button onclick="{parent.close}" class="btn btn-default">Close </button> <button type="submit" __disabled="{parent.saving}" class="btn btn-primary">Save Changes</button> </div> </div><br> <div class="alert alert-info"> <p>Any changes made to Member Details may require the member to sign out and back in again to take effect.</p> </div> </formhorizontal> <div class="row"> <div class="col-xs-12"><br> <div if="{err}" class="alert alert-danger"> <p>{err.message}</p> </div> </div> </div> <p> <br></p> </div> </div> </div>', '.teamadmin .nav-tabs { border: 0px; } .teamadmin tbody tr:hover td { background-color: #ddd; cursor: pointer; } .teamadmin .table.table-striped > tbody > tr.selected > td { background-color: #d60b52; border: 1px solid #d60b52; color: #fff; } .teamadmin .formButton { padding: 5px 10px; border: 1px solid #ddd; margin: 3px; } .teamadmin .formButton.active { border: 1px solid #d60b52; } .teamadmin .tabpanel { background: #fff; -webkit-box-shadow: 0 5px 5px rgba(0,0,0,0.1); box-shadow: 0 5px 5px rgba(0,0,0,0.1); padding: 15px; } .teamadmin .tabpanel .panel-body { -webkit-box-shadow: 0 0px 5px rgba(0,0,0,0.1); box-shadow: 0 0px 5px rgba(0,0,0,0.1); } .teamadmin .avatar { border: 1px dotted #ccc; padding: 15px; margin-bottom: 20px; width: 150px; } .teamadmin .avatar img { max-height: 100px; max-width: 100px; display: block; margin: 0 auto; }', '', function(opts) {
var Resource, inv_resource, resource, xhr;

xhr = require("../libs/xhr.coffee");

Resource = require('riot-kit/utils/apiResource.coffee');

resource = new Resource('/duocms/api/team', true);

inv_resource = new Resource('/duocms/api/team_invoices', true);

this.password = null;

this.tab = "orgdetails";

this.saving = false;

this.org = {};

this.cachebuster = "";

this.service_needsOptions = ["Asthma Management", "Chronic Obstructive Pulmonary Disorder (COPD)", "Community Safety Initiatives", "Dementia/Alzheimers Support", "Diabetes Management", "Domestic Abuse", "Epilepsy Management", "Falls Prevention", "Frailty", "Heart Failure", "Hospital Discharge", "Housing Provision", "Incontinence", "Keeping Safe At Home", "Keeping Safe Outside the Home", "Learning Disabilities", "Mental Health Issues", "Parkinsons Disease", "Personal Care", "Physical Disabilities", "Staying Independent at Home", "Stroke Care", "Unwanted Callers or Intruders", "Witness Harrassment"];

this.services_offeredOptions = ["Telecare Monitoring- In House", "Telecare Monitoring - Outsourced", "Telehealth Monitoring - In House", "Telehealth Monitoring - Outsourced", "Assessment of & Installation of TEC", "Responder Services", "Supply of TEC Equipment", "Commissioner of Service"];

this.serviceGeographyOptions = [
  {
    "value": "",
    "label": "Select"
  }, {
    "value": "1",
    "label": "Regional"
  }, {
    "value": "2",
    "label": "United Kingdom"
  }, {
    "value": "3",
    "label": "Europe"
  }, {
    "value": "4",
    "label": "North America"
  }, {
    "value": "5",
    "label": "South America"
  }, {
    "value": "6",
    "label": "Australia"
  }, {
    "value": "7",
    "label": "Asia"
  }, {
    "value": "8",
    "label": "Worldwide"
  }
];

this.on("mount", function() {
  this.loadlist();
  return this.getOrg();
});

this.loadlist = (function(_this) {
  return function() {
    _this.update({
      loading: true
    });
    _this.password = "";
    return resource.get(function(team) {
      _this.team = team;
      _this.loading = false;
      return _this.update();
    });
  };
})(this);

this.get = (function(_this) {
  return function(e) {
    var user;
    user = e.item;
    _this.update({
      user: null,
      loading: true
    });
    _this.password = "";
    _this.pwfield = "text";
    return resource.get({
      id: user.id
    }, function(user1, err) {
      _this.user = user1;
      _this.err = err;
      _this.loading = false;
      _this.password = null;
      return _this.update();
    });
  };
})(this);

this.uploadimage = (function(_this) {
  return function(file) {
    var formData, self;
    formData = new FormData();
    formData.append("file", file);
    xhr = new XMLHttpRequest();
    xhr.open('POST', '/duocms/api/team/upload_logo?_csrf=' + window.csrf, true);
    self = _this;
    xhr.onload = function() {
      var resp;
      resp = JSON.parse(this.response);
      self.cachebuster = +(new Date());
      return self.update();
    };
    return xhr.send(formData);
  };
})(this);

this.save = (function(_this) {
  return function(e) {
    e.preventDefault();
    _this.saving = true;
    if (_this.password === _this.password2 && _this.password.length > 7) {
      _this.user.password = _this.password;
    }
    return resource.save(_this.user, function(user, err) {
      _this.err = err;
      return setTimeout(function() {
        _this.saving = false;
        if (!_this.errb) {
          _this.user = null;
          _this.loadlist();
        }
        return _this.update();
      }, 1000);
    });
  };
})(this);

this.getOrg = (function(_this) {
  return function(e) {
    return xhr("GET", "/duocms/api/team/org", null, function(res) {
      var base, base1;
      _this.org = res.body.data;
      if ((base = _this.org).service_needs == null) {
        base.service_needs = "";
      }
      if ((base1 = _this.org).services_offered == null) {
        base1.services_offered = "";
      }
      return _this.update();
    });
  };
})(this);

this.saveOrg = (function(_this) {
  return function(e) {
    _this.update({
      saving: true
    });
    _this.org.description = _this.org.description.substr(0, 999);
    return xhr("POST", "/duocms/api/team/org", _this.org, function(res) {
      return setTimeout(function() {
        _this.update({
          saving: false
        });
        _this.org = res.body.data;
        return _this.update();
      }, 1000);
    });
  };
})(this);

this.updateOrgCheck = (function(_this) {
  return function(val, e) {
    var name;
    name = e.target.name;
    _this.org[name] = e.target.checked ? _this.org[name].split(", ").concat(val).join(", ") : _this.org[name].replace(val, "").replace(/ ?, ?/g, "");
    return _this.update();
  };
})(this);

this.addUser = (function(_this) {
  return function() {
    return _this.user = {};
  };
})(this);

this.removeUser = (function(_this) {
  return function() {
    return resource.remove({
      id: _this.user.id
    }, function(user1, err) {
      _this.user = user1;
      _this.err = err;
      if (!_this.err) {
        _this.user = null;
        _this.loadlist();
      }
      return _this.update();
    });
  };
})(this);

this.passupdate = (function(_this) {
  return function(e) {
    return _this.update({
      password: e.target.value
    });
  };
})(this);

this.passupdate2 = (function(_this) {
  return function(e) {
    return _this.update({
      password2: e.target.value
    });
  };
})(this);

this.userupdate = (function(_this) {
  return function(e) {
    if (e.target.type === "checkbox") {
      return _this.user[e.target.name] = e.target.checked;
    } else {
      return _this.user[e.target.name] = e.target.value;
    }
  };
})(this);

this.orgupdate = (function(_this) {
  return function(e) {
    var value;
    if (e.target.type === "checkbox") {
      _this.org[e.target.name] = e.target.checked;
    } else {
      value = e.target.value;
      _this.org[e.target.name] = value;
    }
    return _this.update();
  };
})(this);

this.close = (function(_this) {
  return function() {
    _this.user = null;
    return _this.update();
  };
})(this);

this.settab = (function(_this) {
  return function(e) {
    return _this.update({
      tab: e.target.name
    });
  };
})(this);
});
    
  